<template>
  <v-dialog :value="value" @input="$emit('input', false)" max-width="500px" persistent>
    <v-card dark rounded="xl">
      <v-toolbar flat dense dark color="grey darken-3">
        <v-toolbar-title class="font-weight-bold">📣 Neuer Broadcast</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="pa-4">
        <v-form ref="form" v-model="isValid">
          <v-textarea
            v-model="textContent"
            label="Dein Broadcast..."
            placeholder="Wichtige Info an alle..."
            filled
            rounded
            dense
            rows="3"
            no-resize
            class="mb-2"
            :rules="[(v) => !!(v && v.trim()) || 'Nachricht darf nicht leer sein']"></v-textarea>

          <v-text-field
            v-model="searchQuery"
            placeholder="Empfänger-Gruppen suchen..."
            filled
            rounded
            dense
            hide-details
            dark
            clearable
            prepend-inner-icon="mdi-magnify"
            class="mb-2"></v-text-field>
        </v-form>

        <v-list dark color="transparent" style="max-height: 30vh; overflow-y: auto">
          <v-list-item-group v-model="selectedGroupIds" multiple>
            <v-list-item v-for="group in filteredGroups" :key="group._id" :value="group._id" class="mb-1 glass-card" rounded="lg">
              <v-list-item-avatar color="grey darken-2" class="mr-3">
                <v-img v-if="group.bild" :src="'/img/profilbilder/' + group.bild"></v-img>
                <v-icon v-else dark>mdi-account-group</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{ group.name }}</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-checkbox :input-value="selectedGroupIds.includes(group._id)" color="primary"></v-checkbox>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-btn text @click="closeDialog">Abbrechen</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" rounded depressed large :disabled="!isValid || selectedGroupIds.length === 0" @click="sendBroadcast">
          Senden ({{ selectedGroupIds.length }})
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex"
export default {
  name: "BroadcastDialog",
  props: ["value"], // 'message'-Prop wird nicht mehr gebraucht

  data() {
    return {
      isValid: false,
      searchQuery: "",
      textContent: "", // <-- NEU
      selectedGroupIds: [],
    }
  },

  computed: {
    ...mapState("chatStore", ["chatGroups"]),

    filteredGroups() {
      // (Logik 1:1 wie bei 'Forward')
      const query = this.searchQuery.toLowerCase().trim()
      if (!query) return this.chatGroups
      return this.chatGroups.filter((g) => g.name.toLowerCase().includes(query))
    },
  },

  methods: {
    // NEU: 'broadcastMessage'-Action mappen
    ...mapActions("chatStore", ["broadcastMessage"]),

    getGroupInitials(name) {
      if (!name) return "G"
      const words = name.trim().split(" ")
      if (words.length > 1) {
        return (words[0][0] + (words[1][0] || "")).toUpperCase()
      }
      return name.substring(0, 2).toUpperCase()
    },

    // NEU: 'sendBroadcast'-Methode
    sendBroadcast() {
      if (!this.$refs.form.validate()) return // Formular validieren

      this.broadcastMessage({
        textContent: this.textContent,
        targetGroupIds: this.selectedGroupIds,
      })
      this.closeDialog()
    },

    closeDialog() {
      // Aufräumen
      this.selectedGroupIds = []
      this.searchQuery = ""
      this.textContent = ""
      if (this.$refs.form) this.$refs.form.resetValidation()
      this.$emit("input", false)
    },
  },
}
</script>

<style lang="scss" scoped>
/* (Kopier die '.glass-card'-Styles aus ChatGroupList.vue hierher) */
.glass-card {
  background-color: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
  transition: all 0.2s ease-out;
}
</style>
